import { run } from 'vanilla-cookieconsent';
import 'vanilla-cookieconsent/dist/cookieconsent.css';

const configDefaults = {
  title: 'Aviso de Cookies',
  description: 'Utilizamos cookies propias y de terceros para mejorar tu experiencia de navegación y analizar el tráfico de la web.',
  info_title: 'Más información',
  info_description: 'Revisa nuestra política de privacidad y cookies.',
  privacyUrl: '#',
};

const rawCookieConfig = window.cookieConfig || {};

// `window.cookieConfig` comes from ACF Options fields: it exists as soon as
// the theme boots, but its values stay empty strings until an admin opens
// and saves Theme Settings > Cookies at least once. Fall back per key
// rather than spreading, so an empty string doesn't win over the default.
const cookieConfig = Object.fromEntries(
  Object.keys(configDefaults).map((key) => [
    key,
    rawCookieConfig[key] || configDefaults[key],
  ]),
);

function updateGoogleConsent(status) {
  if (typeof window.gtag !== 'function') return;

  window.gtag('consent', 'update', {
    ad_storage: status,
    ad_user_data: status,
    ad_personalization: status,
    analytics_storage: status,
  });

  if (status === 'granted') {
    window.dataLayer.push({ event: 'cookie_consent_analytics' });
  }
}

function preventLenisScroll() {
  document.getElementById('cc-main')?.setAttribute('data-lenis-prevent', '');
}

export default function setCookieConsent() {
  document.addEventListener('cc:onModalReady', preventLenisScroll);

  run({
    guiOptions: {
      consentModal: {
        layout: 'box inline',
        position: 'bottom right',
        equalWeightButtons: true,
        flipButtons: false,
      },
      preferencesModal: {
        layout: 'box',
        position: 'right',
        equalWeightButtons: true,
        flipButtons: false,
      },
    },

    categories: {
      necessary: {
        readOnly: true,
        enabled: true,
      },
      analytics: {
        enabled: false,
        autoClear: {
          cookies: [
            { name: /^(_ga|_gid)/ },
          ],
        },
      },
    },

    onConsent: ({ cookie }) => {
      updateGoogleConsent(cookie.categories.includes('analytics') ? 'granted' : 'denied');
    },

    onChange: ({ cookie, changedCategories }) => {
      if (changedCategories.includes('analytics')) {
        updateGoogleConsent(cookie.categories.includes('analytics') ? 'granted' : 'denied');
      }
    },

    language: {
      default: 'es',
      translations: {
        es: {
          consentModal: {
            title: cookieConfig.title,
            description: cookieConfig.description,
            acceptAllBtn: 'Aceptar todas',
            acceptNecessaryBtn: 'Solo necesarias',
            showPreferencesBtn: 'Gestionar preferencias',
            footer: `<a href="${cookieConfig.privacyUrl}">Política de Privacidad</a>`,
          },
          preferencesModal: {
            title: 'Configuración de cookies',
            saveSettingsBtn: 'Guardar ajustes',
            acceptAllBtn: 'Aceptar todas',
            rejectAllBtn: 'Rechazar todas',
            closeIconLabel: 'Cerrar',
            serviceCounterLabel: 'Servicios',
            sections: [
              {
                title: 'Uso de cookies',
                description: 'Utilizamos cookies para garantizar las funcionalidades básicas del sitio web y mejorar tu experiencia en línea.',
              },
              {
                title: 'Cookies técnicas',
                description: 'Estas cookies son esenciales para el correcto funcionamiento del sitio web, por ejemplo, para la autenticación del usuario.',
                linkedCategory: 'necessary',
              },
              {
                title: 'Cookies de Analítica',
                description: 'Las cookies utilizadas para analítica ayudan a recopilar datos que permiten a los servicios comprender cómo interactúan los usuarios con ellos. Esta información permite mejorar el contenido y desarrollar mejores funcionalidades que optimicen la experiencia del usuario.',
                linkedCategory: 'analytics',
                cookieTable: {
                  headers: {
                    name: 'Nombre',
                    domain: 'Servicio',
                    description: 'Descripción',
                    expiration: 'Caducidad',
                  },
                  body: [
                    {
                      name: '_ga',
                      domain: 'Google Analytics',
                      description: 'Cookie establecida por <a href="https://business.safety.google/adscookies/" target="_blank">Google Analytics</a> para rastrear el comportamiento del usuario.',
                      expiration: 'Caduca después de 12 meses',
                    },
                    {
                      name: '_gid',
                      domain: 'Google Analytics',
                      description: 'Cookie establecida por <a href="https://business.safety.google/adscookies/" target="_blank">Google Analytics</a> para distinguir a los usuarios.',
                      expiration: 'Caduca después de 24 horas',
                    },
                  ],
                },
              },
              {
                title: cookieConfig.info_title,
                description: cookieConfig.info_description,
              },
            ],
          },
        },
      },
    },
  });
}
